<template>
    <div class="tag-container">
        <div class="twoBtn" v-if="data.has_intel_tag && data.has_intel_tag_model">
            <p :class="{un: !data.transcode_finish,load: isRec}" @click="inteltag">自动识别</p>
            <p @click="setTag">添加自定义标签</p>
        </div>
        <div @click="setTag" class="singleBtn" v-if="!data.has_intel_tag && data.has_intel_tag_model">添加自定义标签</div>
        <div v-for="(item,index) in formatList" :key="index" v-show="!data.isStream && !data.has_intel_tag_model" class="tagInput">
            <input placeholder="请输入自定义标签，回车添加" type="text" maxlength="20" v-model="item.value" @keydown.enter="addTag(item.type, item.value)">
        </div>
        <newMaterialLoad v-if="isLoading"></newMaterialLoad>
        <div v-if="tagList.length == 0 && !isLoading" class="empty">
            <img src="@assets/img/common/tagNone.png" alt="">
            <p>暂无标签</p>
        </div>
        <ul v-if="tagList.length > 0 && !isLoading">
            <template>
                <!-- <li v-if="item.type == 'time'" :key="index">
                    <p class="time">
                        <img src="@assets/img/material/time.png" alt="">
                        时间
                    </p>
                    <ul>
                        <li v-for="(val,key) in item.list" :key="key" :class="canEdit ? 'on' : ''">
                            <span @click="clickTag(val)">{{val.TagName}}</span>
                            <img v-if="val.available" @click="delTag(index,key)" src="@assets/img/material/greyCloseIcon.svg" alt="">
                            <ul v-if="val.timeLine.length > 0">
                                <span></span>
                                <li @click="timeJump(items.start)" v-for="(items,indexs) in val.timeLine" :key="indexs">{{items.start}} - {{items.end}}</li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li v-if="item.type == 'location'" :key="index">
                    <p class="address">
                        <img src="@assets/img/material/address.png" alt="">
                        地点
                    </p>
                    <ul>
                        <li v-for="(val,key) in item.list" :key="key" :class="canEdit ? 'on' : ''">
                            <span @click="clickTag(val)">{{val.TagName}}</span>
                            <img v-if="val.available" @click="delTag(index,key)" src="@assets/img/material/greyCloseIcon.svg" alt="">
                            <ul v-if="val.timeLine.length > 0">
                                <span></span>
                                <li @click="timeJump(items.start)" v-for="(items,indexs) in val.timeLine" :key="indexs">{{items.start}} - {{items.end}}</li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li v-if="item.type == 'people'" :key="index">
                    <p class="user">
                        <img src="@assets/img/material/user.png" alt="">
                        身份职位
                    </p>
                    <ul>
                        <li v-for="(val,key) in item.list" :key="key" :class="canEdit ? 'on' : ''">
                            <span @click="clickTag(val)">{{val.TagName}}</span>
                            <img v-if="val.available" @click="delTag(index,key)" src="@assets/img/material/greyCloseIcon.svg" alt="">
                            <ul v-if="val.timeLine.length > 0">
                                <span></span>
                                <li @click="timeJump(items.start)" v-for="(items,indexs) in val.timeLine" :key="indexs">{{items.start}} - {{items.end}}</li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li v-if="item.type == 'time'" :key="index">
                    <p class="status">
                        <img src="@assets/img/material/status.png" alt="">
                        组织结构
                    </p>
                    <ul>
                        <li v-for="(val,key) in item.list" :key="key" :class="canEdit ? 'on' : ''">
                            <span @click="clickTag(val)">{{val.TagName}}</span>
                            <img v-if="val.available" @click="delTag(index,key)" src="@assets/img/material/greyCloseIcon.svg" alt="">
                            <ul v-if="val.timeLine.length > 0">
                                <span></span>
                                <li @click="timeJump(items.start)" v-for="(items,indexs) in val.timeLine" :key="indexs">{{items.start}} - {{items.end}}</li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li v-if="item.type == 'time'" :key="index">
                    <p class="keyword">
                        <img src="@assets/img/material/keyword.png" alt="">
                        关键词（其他）
                    </p>
                    <ul>
                        <li v-for="(val,key) in item.list" :key="key" :class="canEdit ? 'on' : ''">
                            <span @click="clickTag(val)">{{val.TagName}}</span>
                            <img v-if="val.available" @click="delTag(index,key)" src="@assets/img/material/greyCloseIcon.svg" alt="">
                            <ul v-if="val.timeLine.length > 0">
                                <span></span>
                                <li @click="timeJump(items.start)" v-for="(items,indexs) in val.timeLine" :key="indexs">{{items.start}} - {{items.end}}</li>
                            </ul>
                        </li>
                    </ul>
                </li> -->
                <li v-for="(item,index) in tagList" :key="index">
                    <p class="keyword">
                        <img src="@assets/img/material/keyword.png" alt="">
                        {{item.title}}
                    </p>
                    <ul>
                        <li v-for="(val,key) in item.list" :key="key" :class="canEdit ? 'on' : ''">
                            <span @click="clickTag(val.TagName)" v-html="val.TagName"></span>
                            <img v-if="val.available" @click="delTag(index,key)" src="@assets/img/material/greyCloseIcon.svg" alt="">
                            <ul v-if="val.timeLine.length > 0">
                                <span></span>
                                <li @click="timeJump(items.start)" v-for="(items,indexs) in val.timeLine" :key="indexs">{{items.start}} - {{items.end}}</li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import store from "@common/store";
import { Notification } from 'element-ui';

export default {
    name: 'newMaterialTag',
    data() {
        return {
            isLoading: false,
            tagValue: '',
            tagList: [],
            formatList: [],
            isRec: false
        }
    },
    props: {
        data: {
            type: Object
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        keywords: {
            type: String
        }
    },
    methods: {
        inteltag() {
            if(!this.data.transcode_finish || this.isRec) return

            const info = {
                id: this.data.id
            };

            common.myFetch(apis.inteltag, info).then(r => {
                if (r) {
                    this.$toast(r)
                    this.isRec = true
                }
            });
        },
        timeJump(time) {
            this.$emit('timeJump', time)
        },
        setTag() {
            this.$TagInput(this.formatList).then(res => {
                if(res){
                    let info = {
                        id: this.data.id,
                        tag_json: JSON.stringify(res)
                    }
                    common.myFetch(apis.addtagnew, info).then(r => {
                        if (r) {
                            this.getTagList()
                        }
                    });
                }
            })
        },
        setAlert(e) {
            // console.log(e)
            // Notification({
            //     customClass: 'wp',
            //     type: 'success',
            //     title: '智能识别成功',
            //     message: e.content.content.pickup,
            //     offset: 40,
            //     duration: 3000
            // })
            this.isRec = false;
            this.getTagList()
        },
        clickTag(name) {
            // console.log(this.data.isStream)
            if(this.data.isStream){
                store.commit('setTag',name);
                this.$emit('closeBg')
            }
        },
        addTag(type,value) {
            const info = {
                id: this.data.id,
                tag_json: JSON.stringify([{
                    type: type,
                    tags: value
                }])
            };

            if (value) {
                common.myFetch(apis.addtagnew, info).then(r => {
                    if (r) {
                        this.formatList.forEach(el => {
                            el.value = ''
                        })
                        this.getTagList()
                    }
                });
            }
        },
        delTag(index,key) {
            let type = this.tagList[index].type
            let TagName = this.tagList[index].list[key].TagName

            const info = {
                id: this.data.id,
                type: type,
                tag: TagName
            };

            common.myFetch(apis.deltagnew, info).then(r => {
                if (r) {
                    if(r){
                        this.$toast(r)
                        this.getTagList()
                    }
                }
            });
        },
        setLeft() {
            let rightContainer = document.querySelectorAll('.content-container .right-container')
            let li = document.querySelectorAll('.tag-container > ul > li > ul > li')

            for (let index = 0; index < li.length; index++) {
                const element = li[index];
                if(element.offsetLeft - rightContainer[0].offsetLeft < 80){
                    element.classList.add('left')
                }
            }
        },
        getTagList() {
            const info = {
                id: this.data.id,
                keywords: this.keywords ? this.keywords : '',
                search_from: 'bubble'
            };

            common.myFetch(apis.fileTags, info).then(r => {
                if (r) {
                    // console.log(r)
                    if(r){
                        this.tagList = r.tags
                        this.isRec = r.tagTranscoding
                        this.$nextTick(() => {
                            this.setLeft()
                        })
                    }
                }
            });
        },
        getFormat() {
            common.myFetch(apis.tagformat).then(res => {
                res.list.forEach(el => {
                    el.value = ''
                });

                this.formatList = res.list
            })
        }
    },
    mounted() {
        console.log(this.data)
        // if(this.data.tags){
        //     this.tagList = this.data.tags.split(",");
        // }

        common.handleSocket(this.setAlert, "tag_transcode");
        // this.isRec = this.data.tagTranscoding

        if(!this.data.isStream){
            this.getTagList()

            this.getFormat()
        }else{
            this.tagList = this.data.tags
            
            this.$nextTick(() => {
                this.setLeft()
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .tag-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 14px 20px;
        box-sizing: border-box;

        .singleBtn {
            width: 100%;
            height: 32px;
            line-height: 32px;
            border-radius: 4px;
            border: 1px solid #41B48C;
            box-sizing: border-box;
            text-align: center;
            font-size: 14px;
            color: #41B48C;
            user-select: none;
            cursor: pointer;
            margin-bottom: 30px;
        }

        .twoBtn {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-bottom: 30px;

            p {
                width: 173px;
                height: 32px;
                line-height: 32px;
                background: #41B48C;
                border-radius: 4px;
                color: #FFF;
                font-size: 14px;
                text-align: center;
                user-select: none;
                cursor: pointer;

                &.un {
                    opacity: 0.5;
                }

                &.load {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    opacity: 0.5;

                    &:before {
                        display: inline-flex;
                        content: '';
                        width: 20px;
                        height: 20px;
                        background: url('../../../assets/img/common/loading.gif') no-repeat;
                        background-size: 100% 100%;
                        background-position: center center;
                        margin-right: 5px;
                    }
                }

                &:nth-last-of-type(1) {
                    width: 173px;
                    height: 32px;
                    line-height: 32px;
                    background: transparent;
                    border-radius: 4px;
                    border: 1px solid #41B48C;
                    box-sizing: border-box;
                    color: #41B48C;
                }
            }
        }

        .empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            padding: 70px 0 0;
            box-sizing: border-box;
            user-select: none;

            img {
                width: 44px;
                height: 44px;
            }

            p {
                font-size: 14px;
                line-height: 20px;
                color: #050F0F;
                margin-top: 14px;
            }   
        }

        .tagInput {
            width: 100%;
            height: 40px;
            background: rgba(207, 215, 219, 0.2);
            border-radius: 6px;
            padding: 0 20px;
            box-sizing: border-box;
            margin-bottom: 20px;

            input {
                width: 100%;
                height: 100%;
                background: transparent;
                font-size: 14px;

                &::placeholder {
                    color: #B9C3C3;
                }
            }
        }

        & > ul {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            flex: 1;
            min-height: 0;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(#D8D8D8, 1);
                border-radius: 5px;
            }

            & > li {
                display: flex;
                flex-direction: column;
                width: 100%;

                &>p {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    img {
                        width: 18px;
                        height: 18px;
                        margin-right: 8px;
                    }

                    font-size: 14px;
                    line-height: 20px;
                    color: #050F0F;
                    margin-bottom: 15px;
                }

                &>ul {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    

                    &>li {
                        position: relative;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        min-height: 30px;
                        // line-height: 20px;
                        min-width: 68px;
                        padding: 0 20px;
                        box-sizing: border-box;
                        border-radius: 4px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        background: rgba(185,195,195,0.2);
                        font-size: 14px;
                        color: #0B131F;
                        font-weight: 500;
                        user-select: none;
                        cursor: pointer;

                        &:hover {
                            background: #41b48c;
                            color: #FFF !important;
                        }

                        &.on {
                            padding: 0 4px 0 20px;
                        }

                        img {
                            margin-left: 16px;
                            user-select: none;
                            cursor: pointer;
                        }

                        &:hover {
                            ul {
                                display: flex;
                            }
                        }

                        &.left {
                            ul {
                                transform: translate(0, 0);
                                left: 0;
                            }
                        }

                        ul {
                            position: absolute;
                            top: 30px;
                            left: 50%;
                            z-index: 99;
                            // transform: translate(-30%, 0);
                            transform: translate(-50%, 0);
                            display: none;
                            flex-direction: column;
                            width: 152px;
                            background: #FFFFFF;
                            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                            border-radius: 4px;

                            span {
                                display: block;
                                width: 100%;
                                height: 10px;
                                background: transparent;
                            }

                            li {
                                width: 152px;
                                height: 30px;
                                font-size: 13px;
                                line-height: 30px;
                                color: #323B4B;
                                user-select: none;
                                cursor: pointer;
                                text-align: center;

                                &:hover {
                                    background: rgba(65, 180, 140, 0.15);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>

<style lang="less">
.tag-container {

    & > ul {
        & > li {
            & > ul {
                & > li {
                    &:hover {
                        em {
                            color: #FFF;
                        }
                    }
                }
            }
        }
    }
    

    em {
        color: #41b48c;
        font-style: normal;
    }
}
</style>